import React, { ButtonHTMLAttributes, FunctionComponent } from 'react';

export const Button: FunctionComponent<ButtonHTMLAttributes<HTMLButtonElement>> = props => <button {...props} />;
